import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Server from './Server';
import {ToastContainer, ToastStore} from 'react-toasts';

import RegisterStyles from './Register.css';
import FormGroupStyles from './components/FormGroup.css';
import CustomInputStyles from './components/CustomInput.css';

import WarningMessage from './components/WarningMessage';

class Register extends Component {

    constructor(props) {

        super(props);

        this.state = {
            email: "",
            password: "",
            passwordAgain: "",
            terms: false,
            loginStatusMsg: "",
            firstName: "",
            lastName: "",
            tel: "",
            address1: "",
            address2: "",
            address3: "",
            buttonEnabled: true,
            passwordRequirements: {
                length: false,
                number: false,
                letter: false
            },
            showPasswordWarning: false
        };

    }

    disableButton = () => { this.setState({ buttonEnabled: false }) }
    enableButton = () => { this.setState({ buttonEnabled: true }) }

    onInputChange = (e) => {

        let modifiedField = e.target.id;
        let modifiedFieldValue = e.target.value;

        let state = {...this.state};
        state[modifiedField] = modifiedFieldValue;

        if (modifiedField === "password") {

            let passwordRequirements = {
                length: false,
                number: false,
                letter: false
            }

            if ( (modifiedFieldValue.length > 7) && (modifiedFieldValue.length < 21) ) {
                passwordRequirements.length = true;
            }

            if (/\d/.test(modifiedFieldValue)) {
                passwordRequirements.number = true;
            }

            let upperCaseLetter = false;
            let lowerCaseLetter = false;

            for (let i = 0; i < modifiedFieldValue.length; i++) {
                if (modifiedFieldValue[i].toLowerCase() != modifiedFieldValue[i].toUpperCase()) {
                    if (modifiedFieldValue[i] === modifiedFieldValue[i].toLowerCase()) {
                        lowerCaseLetter = true;
                    } else if (modifiedFieldValue[i] === modifiedFieldValue[i].toUpperCase()) {
                        upperCaseLetter = true;
                    }
                }
            }

            console.log(upperCaseLetter, lowerCaseLetter);

            if (lowerCaseLetter && upperCaseLetter) {
                passwordRequirements.letter = true;
            }

            state.passwordRequirements = passwordRequirements;

        }

        this.setState(state);

    }

    onCheckboxChange = (e) => {

        let modifiedField = e.target.id;
        let modifiedFieldValue = e.target.checked;

        let state = {...this.state};
        state[modifiedField] = modifiedFieldValue;

        this.setState(state);

    }

    signup = (e) => {

        if (e.target.getAttribute("data-enabled") !== "true") {
            return;
        }

        this.disableButton();

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/signup",
            data: {
                user: {
                    email: this.state.email,
                    password: this.state.password,
                    passwordAgain: this.state.passwordAgain,
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    tel: this.state.tel,
                    address1: this.state.address1,
                    address2: this.state.address2,
                    address3: this.state.address3,
                    address1My: this.state.address1My,
                    address2My: this.state.address2My,
                    postalCodeMy: this.state.postalCodeMy,
                    cityMy: this.state.cityMy,
                    stateMy: this.state.stateMy,
                },
                terms: this.state.terms
            },
            then: function(res) {

                if (res.data.success === false) {
                    this.setState({
                        loginStatusMsg: res.data.data
                    })
                    this.enableButton();
                } else {
                    ToastStore.success("Registration successful. Please verify your email address", 60000);
                    setTimeout(function() {
                        this.props.history.push('/login')
                    }.bind(this), 3000);
                }

            }.bind(this),
            catch: function(e) {
                this.setState({
                    loginStatusMsg: "Unexpected Error"
                })
                this.enableButton();
            }.bind(this)
        })

    }

    componentDidMount() {
        document.title = window.globalVars.pageTitleBefore + "Register" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.signup(e);
        }
    }

    render() {

        return (
            <div className="register">
                <div className="main-container">
                    <h1>Register</h1>
                    <div className="form">
                        <h2>Details</h2>
                        <hr />
                        <div className="group">
                            <div className="form-group">
                                <label for="firstName">First name*</label>
                                <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.firstName} type="text" name="firstName" id="firstName" placeholder="First Name" />
                            </div>
                            <div className="form-group">
                                <label for="lastName">Last name*</label>
                                <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.lastName} type="text" name="lastName" id="lastName" placeholder="Last Name" />
                            </div>
                        </div>
                        <div className="group">
                            <div className="form-group">
                                <label for="email">Email address*</label>
                                <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.email} type="email" name="email" id="email" placeholder="Email address" />
                            </div>
                            <div className="password-requirements">
                                <div className="requirement" data-completed={this.state.passwordRequirements.length}>
                                    8-20 characters
                                </div>
                                <div className="requirement" data-completed={this.state.passwordRequirements.letter}>
                                    upper & lowercase letters
                                </div>
                                <div className="requirement" data-completed={this.state.passwordRequirements.number}>
                                    number(s)
                                </div>
                            </div>
                            <div className="form-group">
                                <label for="password">Password*</label>
                                <input
                                    data-enabled={this.state.buttonEnabled}
                                    onKeyPress={this.handleKeyPress}
                                    onChange={this.onInputChange}
                                    defaultValue={this.state.password}
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Password"
                                    onFocus={() => {
                                        this.setState({
                                            showPasswordWarning: false
                                        })
                                    }}
                                    onBlur={() => {
                                        if (!this.state.passwordRequirements.length || !this.state.passwordRequirements.letter || !this.state.passwordRequirements.number) {
                                            this.setState({
                                                showPasswordWarning: true
                                            })
                                        }
                                    }}
                                />
                            </div>
                            { (this.state.showPasswordWarning) &&
                                <div className="field-warning">Sorry, your password doesn't meet all the requirements yet</div>
                            }
                            <div className="form-group">
                                <label for="passwordAgain">Confirm password*</label>
                                <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.passwordAgain} type="password" name="passwordAgain" id="passwordAgain" placeholder="Confirm Password" />
                            </div>
                        </div>
                        <h2>Address</h2>
                        <hr />
                        { (window.region === "SG") &&
                            <div className="group">
                                <p className="shipping-info">
                                    Shipping outside of {window.countryName}? Please <a href="/contact-us" target="_blank">contact us</a>.
                                </p>
                                <div className="form-group">
                                    <label for="address1">
                                        Address Line 1*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.address1} type="text" name="address1" id="address1" placeholder="Address Line 1" />
                                </div>
                                <div className="form-group extra-label">
                                    <label for="address2">
                                        Floor / Unit Number
                                        <span>(if applicable)</span>
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.address2} type="text" name="address2" id="address2" placeholder="Floor / Unit Number" />
                                </div>
                                <div className="form-group">
                                    <label for="address3">Postal Code*</label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.address3} type="text" name="address3" id="address3" placeholder="Postal Code" />
                                </div>
                            </div>
                        }
                        { (window.region === "MY") &&
                            <div className="group">
                                <p className="shipping-info">
                                    Shipping outside of {window.countryName}? Please <a href="/contact-us" target="_blank">contact us</a>.
                                </p>
                                <div className="form-group">
                                    <label for="address1My">
                                        Address Line 1*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.address1My} type="text" name="address1My" id="address1My" placeholder="Address Line 1" />
                                </div>
                                <div className="form-group">
                                    <label for="address2My">
                                        Address Line 2*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.address2My} type="text" name="address2My" id="address2My" placeholder="Address Line 2" />
                                </div>
                                <div className="form-group">
                                    <label for="postalCodeMy">
                                        Postal Code*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.postalCodeMy} type="text" name="postalCodeMy" id="postalCodeMy" placeholder="Postal Code" />
                                </div>
                                <div className="form-group">
                                    <label for="cityMy">
                                        City*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.cityMy} type="text" name="cityMy" id="cityMy" placeholder="City" />
                                </div>
                                <div className="form-group">
                                    <label for="stateMy">
                                        State*
                                    </label>
                                    <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.stateMy} type="text" name="stateMy" id="stateMy" placeholder="State" />
                                </div>
                            </div>
                        }
                        <h2>Contact</h2>
                        <hr />
                        <div className="group">
                            <div className="form-group extra-label">
                                <label for="number">
                                    Phone number*
                                </label>
                                <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.tel} type="tel" name="number" id="tel" placeholder="Phone number" />
                            </div>
                        </div>
                        <WarningMessage message={this.state.loginStatusMsg} />
                        <div className="options">
                            <div className="clearfix">
                                <div className="terms">
                                    <label className="control control--checkbox">
                                        I agree to the
                                        <a target="_blank" href="/terms">
                                            Terms & Conditions
                                        </a>
                                        <input onChange={this.onCheckboxChange} id="terms" type="checkbox" defaultValue="checked"/>
                                        <div className="control__indicator"></div>
                                    </label>
                                </div>
                                <button data-enabled={this.state.buttonEnabled} className="register-btn" onClick={(e) => {this.signup(e)}}>
                                    Done
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_CENTER}/>
            </div>
        );

    }

}

export default Register;



// WEBPACK FOOTER //
// ./src/Register.js